<template>
  <div 
    v-if="isShow"
    class="bottom-img">
    <v-img
      :src="bottomIcon ? bottomIcon.src : require('@/assets/new-ui/background-image.png')"
      width="100vw"
    />
  </div>
</template>

<script>
export default {
  name: "BottomImage",
  props: ["route"],
  data() {

  },
  computed: {
    isShow() {
      const routeName = this.route
      const show = ['Ticket', 'About'].includes(routeName)
      return show;
    },
    bottomIcon() {
      if (this.$store.getters["auth/getIconSetting"] == null) return null
      return this.$store.getters["auth/getIconSetting"].menu_bottom_icon;
    }
  },
  methods: {

  },
};
</script>

<style>
.bottom-img {
  position: absolute;
  bottom: 0px;
}
</style>
